<template>
    <div class="w-full mt-6 overflow-x-auto">
        <div class="p-2 flex flex-col items-start ml-3">
            <button type="submit" class="button-submit p-2 bg-red" @click="generateReport">
                Generate Report
            </button>
        </div>
        <div class="align-middle bg-white inline-block min-w-full">
            <div class="flex justify-end mb-4"></div>
            <table class="divide-gray-300 min-w-full text-left table-auto">
                <thead class="border-b-2">
                    <tr>
                        <th v-for="(column, index) in columns" :key="index" scope="col"
                            class="px-6 py-5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <FilterableHeaderCell :title="column.name" :param="column.param"
                                :current-ordering="ordering" @switchOrder="onSwitchOrders" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="report in reports" :key="report.id">
                        <td class="px-6 py-5 text-sm text-gray-500">
                            <button @click="reportDownload(report.path)"
                                class="text-gray-500 hover:underline focus:outline-none" type="button">
                                {{ report.path.split('/').pop() }}
                            </button>
                        </td>
                        <td class="px-6 py-5 text-sm text-gray-500">
                            {{
                                report?.created_at?.length === 10
                                    ? new Date(report.created_at).toLocaleDateString("en-US")
                                    : new Date(report.created_at).toLocaleString("en-US")
                            }}
                        </td>
                    </tr>
                    <tr v-if="!reports.length">
                        <td :colspan="columns.length" class="text-center py-10">
                            No reports found
                        </td>
                    </tr>
                </tbody>
            </table>

            <nav class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 sm:rounded-b-lg"
                aria-label="Pagination">
                <div class="flex-1 py-4"></div>
                <div class="hidden sm:block mr-4">
                    <p class="text-sm text-right text-gray-700">
                        <span class="font-medium">{{ currentPage }}</span> of
                        <span class="font-medium">{{ totalPages }}</span>
                    </p>
                </div>
                <div class="flex justify-between sm:justify-end">
                    <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1"
                        class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                        Previous
                    </button>
                    <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages"
                        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                        Next
                    </button>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import FilterableHeaderCell from "@/components/common/FilterableHeaderCell";
import eventBus from "@/utils/eventBus";
export default {
    name: "UserReport",
    components: {
    FilterableHeaderCell,
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            columns: [
                { name: "Report File", param: "path" },
                { name: "Created At", param: "created_at" }
            ],
            reports: [],
            isLoading: false,
            currentPage: 1,
            totalPages: 1,
            pageSize: 10,
            ordering: "-created_at"
        };
    },
    mounted() {
        this.fetchUserReports();
    },
    methods: {
        async reportDownload(path) {
            try {
                this.isLoading = true;
                const response = await this.$alfredService.downloadBillingReport(path);
                const blob = new Blob([response.data], { type: 'text/csv' });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = path.split('/').pop();

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            } catch (error) {
                console.error('Error downloading report:', error);
            } finally {
                this.isLoading = false;
            }
        },

        async fetchUserReports() {
            this.isLoading = true;
            try {
                const response = await this.$alfredService.getUserSpecificReports(
                    this.userId,
                    {
                        page: this.currentPage,
                        size: this.pageSize,
                        ordering: this.ordering,
                    }
                );
                if (response) {
                    this.reports = response.results;
                    this.totalPages = Math.ceil(response.count / this.pageSize);
                }
            } catch (error) {
                console.error("Error fetching reports:", error);
            } finally {
                this.isLoading = false;
            }
        },
        async generateReport() {
            let payload = {
                user_id: this.userId,
            };
            try {
                const response = await this.$alfredService.generateUserSpecificReport(
                    payload
                );
                if (response) {
                    this.fetchUserReports();
                    await eventBus.trigger("notify", {
                        notification: {
                            group: "top-right",
                            text: "User report generated successfully.",
                            type: "success",
                        },
                    });
                }
            } catch (e) {
                await eventBus.trigger("notify", {
                    notification: {
                        group: "top-right",
                        text: e.response.data.error,
                        type: "error",
                    },
                });
            }
        },
        onSwitchOrders(name) {
            let order = this.ordering === name ? `-${name}` : name;
            this.ordering = order;
            this.currentPage = 1;
            this.fetchUserReports();
        },
        goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.totalPages) {
                this.currentPage = pageNumber;
                this.fetchUserReports();
            }
        },
    },
};
</script>

<style scoped></style>
